<div class="register pt-16 md:pt-32">
    <div class="body">
        <div class="mail-container flex flex-col gap-16">
            <div class="inp">
                <fun-input
                    placeholder="nombre@tucorreo.es"
                    [parentForm]="emailForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="email"
                    type="text"
                    [errorLogin]="errorAmount"
                    labelName="E-mail"
                ></fun-input>
            </div>
            <div class="inp">
                <fun-input
                    placeholder="**********"
                    [parentForm]="emailForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="pwd"
                    type="password"
                    [errorLogin]="errorAmount"
                    labelName="{{ 'register.email.password' | translate }}"
                ></fun-input>
            </div>
        </div>
    </div>
</div>
